import {
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Tooltip,
} from '@material-ui/core';
import React, { useState } from 'react';
import EmailDialog from '../../../components/table/EmailDialog';
import { CommonConfig } from '../../../config/common-config';
import downloadImage from '../../../assets/downloadImage.png';
import moment from 'moment';
import CommentIcon from '@material-ui/icons/Comment';
import Dialog from '@material-ui/core/Dialog';
import { Card, CardContent, Typography, CardActions } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';

function EnhancedTableHead(props) {
    const { classes, headcells, action, order, orderBy, onRequestSort, attachment, pageName, remarks } = props;

    const createSortHandler = (property) => (event) => {
        //console.log("hearderID", property);
        onRequestSort(event, property);
    };

    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                <TableCell className={classes.TableHeadCss}>SL No</TableCell>
                {headcells.map((headRow) => {
                    return (
                        <TableCell
                            className={classes.TableHeadCss}
                            key={headRow.id}
                            align="left"
                            sortDirection={orderBy === headRow.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headRow.id}
                                direction={orderBy === headRow.id ? order : 'asc'}
                                onClick={createSortHandler(headRow.id)}
                            >
                                {headRow.label}
                                {orderBy === headRow.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}

                {remarks && (
                    <TableCell align="center" className={classes.TableHeadCss}>
                        Remarks
                    </TableCell>
                )}

                {attachment && (
                    <TableCell align="center" className={classes.TableHeadCss}>
                        Attachment
                    </TableCell>
                )}
                {/* {pageName !== 'itec' && (
                    <TableCell align="left" className={classes.TableHeadCss}>
                        Comment by Clients
                    </TableCell>
                )} */}
                {action && (
                    <TableCell align="left" className={classes.TableHeadCss}>
                        Action
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    TableHeadCss: {
        fontWeight: '700',
        fontFamily: 'Rubik',
        fontSize: '14px',
        color: '#31333F',
        backgroundColor: '#dcdcdc',
    },
    tableRow: {
        height: '50px',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    remarksCss: {
        fontFamily: 'Rubik !important',
    },
    clientRemCss: {},
}));

function descendingComparator(a, b, orderBy) {
    //console.log(a, b, " From descending Comparator");
    //console.log(typeof (a[orderBy]), b[orderBy], " From descending Comparator");

    const x = typeof a[orderBy] === 'string' ? a[orderBy].toLowerCase() : a[orderBy];
    const y = typeof b[orderBy] === 'string' ? b[orderBy].toLowerCase() : b[orderBy];

    if (y < x) {
        return -1;
    }
    if (x > y) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => {
        return el[0];
    });
}
const PaymentTable = ({
    headcells,
    rows,
    action,
    attachment,
    remarks,
    handleGenerateReceipt,
    row,
    pageName,
    handleCount,
    pageDetails,
    prvnxtbt,
}) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const classes = useStyles();
    // const [invoiceUrl, setInvoiceUrl] = useState();
    // const [downloadPath, setDownloadPath] = useState('');
    const [remarksbyClient, setRemaksbyClient] = React.useState();
    const [remarksTitle, setRemaksTitle] = React.useState('');
    const [dialogOpen, setDialogOpen] = React.useState(false);
    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };

    const handleDownload = (paymentUrl) => {
        //console.log("click", invoiceUrl);
        //console.log("click", paymentUrl);
        const downloadPath = `${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${paymentUrl}`;
        // const downloadPath = setDownloadPath(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${invoiceUrl}`);
        window.location.href = downloadPath;
    };

    const handleOpenDialog = (remarksbyclient) => {
        setRemaksTitle('Remarks by Client');
        setRemaksbyClient(remarksbyclient);
        setTimeout(() => {
            setDialogOpen(true);
        }, 200);
    };

    function numberWithCommas(x) {
        x = x.toString();
        const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(x.replace(/,/g, '')));
        return IndianCur;
    }

    const rowData = (rowdata) => {
        // console.log('responseRowData',rowdata);
        return headcells.map((col) => {
            // console.log('colData',col);
            if (col.isConcat && rowdata[col.id]) {
                const subdata = rowdata[col.id];
                const mergedData = col.concatElem.map((concatdata) => {
                    return concatdata.split('.').reduce((acc, item) => {
                        if (Object.prototype.hasOwnProperty.call(acc, item)) {
                            return acc[item];
                        }
                        return '';
                    }, subdata);
                });
                return (
                    <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                        {mergedData.join(' ')}
                    </TableCell>
                );
            }
            if (col.id === 'invoiceId' && col.label === 'Invoice Date') {
                const date = new Date(rowdata.invoiceId.invoiceDate);
                const invoiceDate = moment(date).format('DD-MM-YYYY');
                // const paymentUpdateDate = moment(date).format('DD-MM-YYYY') ? paymentDate : date;
                return (
                    <TableCell align="left" key={rowdata[col.id]}>
                        {invoiceDate}
                    </TableCell>
                );
            }

            // element.invoiceId.invoiceDate = moment(element.invoiceId.invoiceDate).format('DD-MM-YYYY');
            // const paymentRecievedDate = new Date(element.paymentDate).toLocaleDateString();
            // element.paymentDate = moment(paymentRecievedDate).format('DD-MM-YYYY');
            // if (col.date && rowdata[col.id]) {
            //     const date = new Date(rowdata[col.id]).toLocaleDateString();
            //     const paymentDate = moment(date).format('DD-MM-YYYY');
            //     return (
            //         <TableCell align="left" key={rowdata[col.id]}>
            //             {paymentDate}
            //         </TableCell>
            //     );
            // }
            if (col.id === 'totalAmount') {
                // let paymentAmount = Math.round(rowdata.invoiceId.totalAmount);
                // let paymentAmount = numberWithCommas(rowdata.invoiceId.totalAmount);
                return (
                    <TableCell align="left" key={col.id}>
                        {numberWithCommas(rowdata.invoiceId.totalAmount)}
                    </TableCell>
                );
            }
            if (col.id === 'paymentAmount') {
                // let paymentAmount = Math.round(rowdata.invoiceId.totalAmount);
                // let paymentAmount = numberWithCommas(rowdata.invoiceId.totalAmount);
                return (
                    <TableCell align="left" key={col.id}>
                        {numberWithCommas(rowdata.invoiceId.totalAmount)}
                    </TableCell>
                );
            }
            return (
                <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                    {rowdata[col.id]}
                </TableCell>
            );
        });
    };

    const pagination = (propsPagination) => {
        handleCount(propsPagination);
    };
    const pagin = () => {
        const pag = (
            <div
                style={{
                    float: 'right',
                    padding: ' 16px',
                    display: 'flex',
                    alignItems: 'baseline',
                }}
            >
                <div style={{ marginLeft: '10px', paddingBottom: '6px' }}>
                    Showing {pageDetails && pageDetails.number + 1} of {pageDetails && pageDetails.totalPages} Pages
                </div>

                {pageDetails && pageDetails.totalPages > 1 ? (
                    <>
                        <button className="checklistBtn-openService PNButton" onClick={() => pagination('prev')} disabled={prvnxtbt.prvBt}>
                            Previous
                        </button>
                        <button className="checklistBtn-openService PNButton" onClick={() => pagination('next')} disabled={prvnxtbt.nxtBt}>
                            Next
                        </button>
                    </>
                ) : (
                        ''
                    )}
            </div>
        );
        return pag;
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table" size="medium">
                        <EnhancedTableHead
                            classes={classes}
                            headcells={headcells}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            action={action}
                            attachment={attachment}
                            remarks={remarks}
                        // pageName={pageName}
                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((rowdata, index) => {
                                    //console.log('233', rowdata);
                                    const rowDataShow = rowData(rowdata);
                                    const invoiceUrl = rowdata.invoiceId.invoiceUrl;
                                    const paymentUrl = rowdata.paymentUrl;
                                    const remarksbyclient = rowdata.comments;
                                    const modeOfPayment = rowdata.modeOfPayment;

                                    //console.log('229', invoiceUrl);
                                    let slno = 1;
                                    if (page > 0) {
                                        slno = page * rowsPerPage + 1;
                                    }
                                    slno += index;
                                    return (
                                        <TableRow hover tabIndex={-1} key={slno} className={classes.tableRow}>
                                            <TableCell style={{ fontFamily: 'Rubik' }}>
                                                {pageDetails && pageDetails.number > 0 ? slno + pageDetails.number * 10 : slno}
                                            </TableCell>
                                            {rowDataShow}

                                            {remarks && (
                                                <TableCell align="center">
                                                    {modeOfPayment === 'ONLINE' ? null : (
                                                        <CommentIcon onClick={() => handleOpenDialog(remarksbyclient)} />
                                                    )}
                                                </TableCell>
                                            )}

                                            {attachment && (
                                                <TableCell align="center">
                                                    {/* <Tooltip title="download" onClick={() => handleDownload(invoiceUrl)}>
                                                        <IconButton aria-label="download">
                                                            <GetApp />
                                                        </IconButton>
                                                    </Tooltip> */}
                                                    {paymentUrl ? (
                                                        <span
                                                            style={{ marginTop: '-4px', marginRight: '6px' }}
                                                            onClick={() => handleDownload(paymentUrl)}
                                                        >
                                                            <Tooltip title="Download">
                                                                <img
                                                                    src={downloadImage}
                                                                    alt="downloadImage"
                                                                    className="downlaodImg downloadImgTopTable"
                                                                />
                                                            </Tooltip>
                                                        </span>
                                                    ) : null}
                                                </TableCell>
                                            )}

                                            {/* {pageName !== 'itec' && (
                                                <TableCell align="left" style={{ fontFamily: 'Rubik' }}>
                                                    {pageName}
                                                </TableCell>
                                            )} */}
                                            {action && (
                                                <TableCell align="left">
                                                    {/* <Tooltip title="Generate Receipt" row={row} onClick={handleGenerateReceipt}>
                                                        <IconButton aria-label="email">
                                                            <Email />
                                                        </IconButton>
                                                    </Tooltip> */}
                                                    {rowdata.statusId.statusId === 6 ? (
                                                        <TableCell
                                                            align="left"
                                                            style={{ borderBottom: 'none', padding: '0', fontFamily: 'Rubik' }}
                                                        >
                                                            Receipt Generated
                                                        </TableCell>
                                                    ) : (
                                                            <EmailDialog row={rowdata} deleteRow={handleGenerateReceipt} />
                                                        )}
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                // <TableRow>
                                //     <TableCell style={{ height: 53 * emptyRows }} colSpan={10} />
                                // </TableRow>
                                <></>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {pagin()}
            </Paper>

            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                maxWidth="xs"
                fullWidth
                aria-labelledby="customized-dialog-title"
            >
                <div style={{ padding: '16px 0px 16px 16px' }}>
                    <Card>
                        <CardContent
                            className={classes.cardContent}
                            style={{ paddingLeft: '9px', paddingTop: '0px', paddingBottom: '0px' }}
                        >
                            <Typography variant="h6" className={classes.remarksCss}>
                                {remarksTitle}
                            </Typography>
                        </CardContent>
                        <DialogContent className={classes.scrollbarView} style={{ paddingLeft: '10px' }}>
                            <div className={classes.clientRemCss}>{remarksbyClient}</div>
                        </DialogContent>
                    </Card>
                    <CardActions className={classes.cardAction}>
                        <div>
                            <Button
                                variant="contained"
                                color="primary"
                                className="txt-capitalize"
                                onClick={() => setDialogOpen(false)}
                                style={{ width: '10%' }}
                            >
                                {' '}
                                Close
                            </Button>
                        </div>
                    </CardActions>
                </div>
            </Dialog>
        </div>
    );
};

export default PaymentTable;
